var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"purchase-planning-orders-list",attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"setLoading":_vm.setLoading,"persistenceKey":'purchase-planning-orders-list',"loadDataGrid":_vm.loaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }